import React from 'react';
import { Button, CircularProgress, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { dialogStackedActionsSx, dialogStackedButtonSx, StyledDialog } from 'theme/index';
import COLORS from 'theme/colors';

interface CancelAppointmentDialogProps {
  open: boolean;
  onKeep: () => void;
  onConfirmCancel: () => void;
  /**
   * MM-1191: true while the cancellation is being processed - both buttons are disabled (so it can't be sent
   * twice) and Cancel Appointment shows a spinner. Optional: the patient's Manage Appointment page leaves it unset.
   */
  loading?: boolean;
}

const CancelAppointmentDialog = ({ open, onKeep, onConfirmCancel, loading = false }: CancelAppointmentDialogProps) => (
  <StyledDialog open={open} onClose={loading ? undefined : onKeep} maxWidth='xs' fullWidth>
    {/* StyledDialog's own Paper padding (theme/index.ts) stacks with DialogTitle's default
        16px 24px, leaving little width on a phone screen at the default h6 size - shrinking it
        on mobile keeps "Cancel Appointment?" on one line instead of wrapping to two (same fix
        as SelectionConfirmDialog's title). */}
    <DialogTitle sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>Cancel Appointment?</DialogTitle>
    <DialogContent>
      <Typography sx={{ color: COLORS.Text }}>Are you sure you want to cancel this appointment?</Typography>
    </DialogContent>
    {/* Stacked, centred pill buttons sized to their text, on mobile and desktop alike - see
        dialogStackedActionsSx/dialogStackedButtonSx in theme/index.ts. */}
    <DialogActions disableSpacing sx={dialogStackedActionsSx}>
      <Button variant='outlined' onClick={onKeep} disabled={loading} sx={dialogStackedButtonSx}>
        Keep Appointment
      </Button>
      <Button
        variant='contained'
        onClick={onConfirmCancel}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color='inherit' /> : undefined}
        sx={dialogStackedButtonSx}
      >
        Cancel Appointment
      </Button>
    </DialogActions>
  </StyledDialog>
);

export default CancelAppointmentDialog;
